/* eslint-env browser */
(function() {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    );

  if ('serviceWorker' in navigator &&
      (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
    .then(function(registration) {
      // updatefound is fired if service-worker.js changes.
      registration.onupdatefound = function() {
        // updatefound is also fired the very first time the SW is installed,
        // and there's no need to prompt for a reload at that point.
        // So check here to see if the page is already controlled,
        // i.e. whether there's an existing service worker.
        if (navigator.serviceWorker.controller) {
          // The updatefound event implies that registration.installing is set:
          // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
          var installingWorker = registration.installing;

          installingWorker.onstatechange = function() {
            switch (installingWorker.state) {
              case 'installed':
                // At this point, the old content will have been purged and the
                // fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in the page's interface.
                break;

              case 'redundant':
                throw new Error('The installing ' +
                                'service worker became redundant.');

              default:
                // Ignore
            }
          };
        }
      };
    }).catch(function(e) {
      console.error('Error during service worker registration:', e);
    });
  }

  const Router = (name, routes) => {
    return {
      name: name,
      routes: routes
    };
  };

  const pageRouter = new Router('pageRouter', [
    {
      path: '/',
      name: 'Root'
    },
    {
      path: '/sv',
      name: 'Svenska'
    },
    {
      path: '/fi',
      name: 'Suomeksi'
    }
  ]);

  window.onload = function() {
    [].forEach.call(document.querySelectorAll('.imgslide'), function(img) {
      img.setAttribute('src', img.getAttribute('data-src'));
      img.onload = function() {
        img.removeAttribute('data-src');
      };
    });

    let current = 0;
    const slides = document.querySelectorAll('.imgslide');

    setInterval(function() {
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.opacity = 0;
      }

      current = (current === slides.length - 1) ? 0 : current + 1;
      slides[current].style.opacity = 1;
    }, 7500);
  };

  function navigate(event) {
    event.preventDefault();

    const target = event.target ? event.target : event.srcElement;

    let userLang = navigator.language || navigator.userLanguage;
    if (userLang !== 'sv') {
      userLang = 'fi';
    }
    let route = '/' + userLang;

    for (var i = 0; i < target.attributes.length; i++) {
      if (target.attributes[i].nodeName === 'href' && target.attributes[i].value !== '') {
        route = target.attributes[i].value;
        break;
      }
    }

    let routeInfo = pageRouter.routes.filter(r => {
      return r.path === route;
    })[0];

    let oldroute = window.location.pathname;
    let path = '';

    if (!routeInfo) {
      path = '/' + userLang;
    } else if (routeInfo) {
      path = routeInfo.path;
    }

    window.history.pushState({}, '', path);

    if (oldroute !== path) {
      triggerRoute(oldroute.replace('/', ''), path.replace('/', ''));
    }
  }

  function triggerRoute(oldroute, path) {
    document.querySelector('#link' + oldroute + ' a').classList.remove('active');
    document.querySelector('#link' + path + ' a').classList.add('active');
    document.querySelector('#lang' + oldroute).classList.remove('out', 'in');
    document.querySelector('#lang' + path).classList.remove('out', 'in');
    document.querySelector('#lang' + oldroute).classList.add('out');
    document.querySelector('#lang' + path).classList.add('in');

    setTimeout(() => {
      document.querySelector('#lang' + oldroute).classList.toggle('active');
      document.querySelector('#lang' + path).classList.toggle('active');
    }, 1000);
  }

  if (history.pushState) {
    let activeRoutes = document.querySelectorAll('ul.menu li a[href]');
    let currentPath = window.location.pathname;

    [].forEach.call(activeRoutes, route => {
      route.addEventListener('click', navigate, false);
    });

    let userLang = navigator.language || navigator.userLanguage;
    if (userLang !== 'sv') {
      userLang = 'fi';
    }

    let path = '/' + userLang;

    if (currentPath === '/') {
      window.history.pushState({}, '', '/' + userLang);
    } else {
      let route = pageRouter.routes.filter(r => {
        return r.path === currentPath;
      })[0];

      if (route) {
        path = route.path;
      } else {
        window.history.pushState({}, '', '/' + userLang);
      }
    }
    path = path.replace('/', '');
    document.querySelector('ul.menu > li > a.active').classList.remove('active');
    document.querySelector('.thecontent > section.active').classList.remove('active');
    document.querySelector('.thecontent > section.initial').classList.remove('initial');
    document.querySelector('#link' + path + ' a').classList.add('active');
    document.querySelector('#lang' + path).classList.toggle('active');
  }
})();
